import React from 'react';
import { Table, Dropdown } from '../../ui-kit';
import { IconFilter, IconSortDown, IconSortUp } from '../../ui-kit/icons';

import TableRequestedRow from './TableRequestedRow';

const SortIcon = ({ sortUp, ...props }) => {
  const style = { marginLeft: '10px', cursor: 'pointer' };

  const Icon = sortUp ? IconSortDown : IconSortUp;
  return <Icon {...props} style={style} />;
};

const TableRequested = ({
  canRespondOnBehalf,
  constraints,
  currentUserId,
  groupId,
  setSelectedConstraint,
  mayResolve,
  intervals,
  reverseSort,
  selectedConstraint,
  sortByConstraint
}) => (
  <Table bordered condensed className="duty-transaction-candidates">
    <thead className="align-middle">
      <tr>
        <th>{I18n.t('period')}</th>
        <th>{I18n.t('activerecord.attributes.schedule/exchanges/duty_exchange_interval.owner')}</th>
        <th>{I18n.t('groups.types.station')}</th>
        <th
          className="contract-progress"
          dangerouslySetInnerHTML={{
            __html: I18n.t('activerecord.attributes.reporting/contracts/contract.fulfillment_ratio_colored')
          }}
        />
        <th
          className="contract-balance"
          dangerouslySetInnerHTML={{
            __html: I18n.t('activerecord.attributes.reporting/contracts/contract.balance')
          }}
        />
        <th className="contract-constraints">
          {I18n.t('reports.group_reports.contract_fulfillments.constraints')}
          <Dropdown id="groups-filter-dropdown" className="d-inline ms-2" onSelect={setSelectedConstraint}>
            <Dropdown.Toggle variant="secondary" size="sm">
              <IconFilter />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item key={'any'} eventKey={null} active={selectedConstraint === null}>
                {I18n.t('any')}
              </Dropdown.Item>
              <Dropdown.Divider />
              {constraints.map(constraint => (
                <Dropdown.Item key={constraint} eventKey={constraint} active={selectedConstraint === constraint}>
                  {constraint}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {selectedConstraint && <SortIcon sortUp={sortByConstraint > 0} onClick={reverseSort} />}
        </th>
        <th>{I18n.t('attributes.status')}</th>
        <th>{I18n.t('activerecord.attributes.incidents/incident_response.responded_at')}</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {intervals.map(interval => (
        <TableRequestedRow
          key={interval.id}
          mayResolve={mayResolve}
          interval={interval}
          currentUserId={currentUserId}
          selectedConstraint={selectedConstraint}
          groupId={groupId}
          canRespondOnBehalf={canRespondOnBehalf}
        />
      ))}
    </tbody>
  </Table>
);

export default TableRequested;
